import Skeleton from '@mui/material/Skeleton';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useEffectivePageSize } from 'hooks/useEffectivePageSize';

const SKELETON_DELAY_MS = 300;

const SectionLoadingSkeleton: React.FC = () => {
  const pageSize = useEffectivePageSize();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setShow(true), SKELETON_DELAY_MS);
    return () => clearTimeout(id);
  }, []);

  if (!show) return null;

  return (
    <Skeleton
      variant="rectangular"
      animation="wave"
      width={pageSize.width}
      height={pageSize.height}
      sx={{ display: 'block', margin: '12px auto 0' }}
    />
  );
};

export default SectionLoadingSkeleton;
